import { ReactElement, ReactNode, useState } from 'react';
import { useUITranslation } from '../../../hooks';
import {
    UIConfirmationModalContext,
    UIConfirmationModalContextData,
    UIConfirmationModalOpenData
} from '.';
import { UIModal, UIModalFooter, UIModalHeader } from '../ui-modal';

type Props = {
    readonly children?: ReactNode;
};

export function UIConfirmationModalProvider({ children }: Props): ReactElement {
    const { t } = useUITranslation();
    const [data, setData] = useState<UIConfirmationModalOpenData | null>(null);
    const value: UIConfirmationModalContextData = {
        isOpen: !!data,
        open: (data: UIConfirmationModalOpenData) => setData(data),
        close: () => setData(null),
        setLoading: (loading: boolean) => {
            if (data) {
                setData({
                    ...data,
                    loading
                });
            }
        }
    };

    return (
        <>
            <UIConfirmationModalContext.Provider value={value}>
                {children}
            </UIConfirmationModalContext.Provider>
            <UIModal
                isOpen={!!data}
                small
                onClose={() => {
                    setData(null);
                }}
            >
                {data && (
                    <>
                        <UIModalHeader
                            title={data.title}
                            titleProps={{
                                variant: 'basic',
                                bold: false,
                                medium: false
                            }}
                        />
                        <div style={{ height: 10 }} />
                        <UIModalFooter
                            actions={[
                                {
                                    variant: data.confirmVariant || 'primary',
                                    text: data.confirmText || 'Yes',
                                    loading: data.loading,
                                    onClick: () => {
                                        data.onConfirm?.();
                                    }
                                },
                                {
                                    text:
                                        data.cancelText ||
                                        t('shared.labels.cancel'),
                                    disabled: data.loading,
                                    onClick: () => {
                                        data.onCancel?.();
                                    }
                                }
                            ]}
                        />
                    </>
                )}
            </UIModal>
        </>
    );
}
